/**
 * Unregisters the page's service worker, as react-scripts' `serviceWorker.unregister()` did — the app has never
 * registered one, so this only clears one left behind by an old build.
 */
export function unregister() {
	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				console.error(error.message);
			});
	}
}
